import { css } from '@linaria/core';
import { baseUnits, theming } from 'styles/utils';
export const buttonStyles = "omponents__deprecated__Button__Button_styles_ts-buttonStyles-bo0hw7a";
export const loader = "omponents__deprecated__Button__Button_styles_ts-loader-l11e5v6k";

require("./Button.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Button.styles.ts");